import React from 'react';
import { useSelector } from "react-redux";
import ClubTab from "./ClubTab";
import {getAccountAvatars, getClubList} from "../../../store/selectors";

const ClubList = ({  }) => {

    const clubsData = useSelector(getClubList);
    const avatarList = useSelector(getAccountAvatars);

    return (
        <div className={`clubList`}>
            {
                clubsData.map(club => (
                    ( !!club.playerAccount && !club.playerAccount.isGlobal) &&
                    <ClubTab key={club.clubId} club={club} avatar={avatarList[club.clubId]}></ClubTab>
                ))
            }
        </div>
    )
};

export default ClubList;
